import { Badge, Col, Row, Space, Statistic } from "antd";
import { useBuscarReservas } from "../hooks/useBuscarReservas";
import { WarningOutlined } from "@ant-design/icons";
import { TextSubTitle } from "../styles";

export default function AnunciosAtivos() {
  const { reservas } = useBuscarReservas();

  
     return (
    <Space
      direction="vertical"
      size={4}
      style={{ width: "100%", textAlign: "center" }}
      align="center" // para centralizar verticalmente, caso tenha múltiplos itens
    >
      <TextSubTitle>Qtd de Anúncios Ativos</TextSubTitle>
      <Statistic value={36} />
    </Space>
  );
  
}
